

















































import { Component, Prop, Emit, Vue, Watch } from "vue-property-decorator";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

@Component({})
@SearchbarControl("k1searchForm")
@IsMore()
export default class gtSearchbarShort extends Vue {
  @Prop({ default: {} }) model: Object;
  @Prop({ default: false }) loading: Boolean;
  @Prop({ default: 3 }) showNum: Number; // 展示的数量
  @Prop({ default: "handlePageChange" }) pageChangeName: string;
  // TODO: 待优化，JSON配置
  // 注意：组件强依赖gtech-ui，以及相关装饰器
  @Emit("reset")
  handleReset(val) {
    return val;
  }
  // SearchbarControl 里的方法
  @Emit("change")
  handlePageChange(v) {
    return v;
  }

  onDefaultSearchBtnClick() {
    // 默认使用父组件中的handlePageChange方法，强依赖
    try {
      // 默认是handlePageChange
      (this.$parent as any)[this.pageChangeName](1);
    } catch (error) {
      console.warn("get parent component error");
    }
  }

  onDefaultResetBtnClick() {
    (this as any).onResetBtnClick();
    this.onDefaultSearchBtnClick();
    console.log("log");
  }

  get slotsLen() {
    return Object.keys(this.$slots).length;
  }

  getSlotAttrs(slotName) {
    try {
      const firstAttrs = this.$slots && this.$slots[slotName][0];
      let normalAttrs = firstAttrs.data.attrs;
      if (normalAttrs.label) {
        return normalAttrs || "";
      } else {
        // 组件自带prop，就去propData里找
        const attrs = firstAttrs.componentOptions.propsData;
        return attrs;
      }
    } catch (error) {
      return {};
    }
  }
}
